import React from "react";

// icons : feather
import FeatherIcon from 'feather-icons-react';
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export default function AppFormikSelectInline(props) {
    const { 
        formik, 
        stFormClass, 
        labelName, 
        isRequired, 
        formikFieldName, 
        onChange = () => { }, 
        disabled = false, 
        tooltip, 
        style
    } = props;
    const renderTooltipAutoApplyInfo = (props) => <Tooltip {...props}>{tooltip}</Tooltip>;

    return (
        <div className={`st-form ${stFormClass ? stFormClass : ""} ${formik.touched[formikFieldName] && formik.errors[formikFieldName] ? "has-msg msg-error" : ""}`}>
            {labelName ? (
                <label>
                    {labelName}
                    {isRequired && <span className="required ms-1 st-fs-12">(required)</span>}
                    {" "} {tooltip && <OverlayTrigger
                        placement={"top"}
                        overlay={renderTooltipAutoApplyInfo}
                    >
                        <span className="info-icon cursor-pointer st-text-primary ms-2">
                            <FeatherIcon
                                icon="help-circle"
                                size="15"
                                className="icon" />
                        </span>
                    </OverlayTrigger>}
                </label>
            ) : null}
            <div className="media-body st-form-input-container">
                <select
                    style={style}
                    className="form-control"
                    id={formikFieldName}
                    {...formik.getFieldProps(formikFieldName)}
                    onChange={(e) => {
                        formik.setFieldValue(formikFieldName, e.target.value)
                        onChange(e.target.value, e)
                    }}
                    disabled={disabled}
                >
                    {/* all options */}
                    {props.children}
                </select>
                {
                    /* form message */
                    formik.touched[formikFieldName] &&
                    formik.errors[formikFieldName] && (
                        <div className="st-form-msg position-absolute">
                            <p className="st-fs-12">
                                {formik.errors[formikFieldName]}
                            </p>
                        </div>
                    )
                }
            </div>
        </div>
    );
}
